// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Routes, Route } from "react-router-dom";
import { routes } from "./routeConfig";
import RouteRenderer from "../components/auth/RouteRenderer";

// Flatten nested route children so React Router sees every path at the top
// level. Relative child paths are joined under their parent's path.
const flattenRoutes = (routesToFlatten) => {
  const flattened = [];
  routesToFlatten.forEach((route) => {
    if (route.children && route.children.length > 0) {
      route.children.forEach((childRoute) => {
        const fullPath = childRoute.path.startsWith("/")
          ? childRoute.path
          : `${route.path}/${childRoute.path}`;
        flattened.push({ ...childRoute, path: fullPath });
      });
    } else {
      flattened.push(route);
    }
  });
  return flattened;
};

const allRoutes = flattenRoutes(routes);

const AppRoutes = () => (
  <Routes>
    {allRoutes.map((route) => (
      <Route
        key={route.path}
        path={route.path}
        element={<RouteRenderer route={route} />}
      />
    ))}
  </Routes>
);

export default AppRoutes;
